<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED">For Mark, who has believed from the beginning.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?039b8ae2